import { css } from '@emotion/react';
import { Trans, useTranslation } from '@frontend/i18n';
import { Heading, Text } from '@frontend/design-system';
import { LocationSchedulingModeList } from './location-scheduling-mode-list';

export const OnlineSchedulingModeSetting = () => {
  const { t } = useTranslation('schedule-settings');

  return (
    <section css={containerStyles}>
      <Heading level={3}>{t('Online Scheduling Mode')}</Heading>
      <div>
        <Text>{t('Determines how a time selected by a patient is placed on your calendar.')}</Text>
        <ul css={{ paddingLeft: 'var(--fabric-space-padding-lg)' }}>
          <Trans t={t}>
            <Text as='li'>
              <strong>Request Scheduling</strong> The time selected by your patients need to be approved before being
              confirmed. If you switch to this mode nothing will change about the appointments currently on your
              schedule.
            </Text>
            <Text as='li'>
              <strong>Direct Booking</strong> The time selected by your patients is automatically added to your schedule
              without any need for approval. If you switch to this mode any appointments that have been requested will
              still need approval.
            </Text>
          </Trans>
        </ul>
      </div>
      <LocationSchedulingModeList />
    </section>
  );
};

const containerStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--fabric-space-gap-lg);
`;
